import React, { useState, useEffect } from 'react';
import "./Services.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaRegMoneyBillAlt, FaCalculator, FaChartLine, FaShieldAlt, FaRegListAlt, FaHandHoldingUsd, FaGifts, FaHome, FaFileContract, FaUserTie } from 'react-icons/fa';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
const Services = () => {
  const [showAll, setShowAll] = useState(false);

  const individualServices = [
    { name: "Tax Filing", icon: <FaRegMoneyBillAlt /> },
    { name: "Tax Consultation", icon: <FaCalculator /> },
    { name: "Tax Planning", icon: <FaChartLine /> },
    { name: "Tax Optimization", icon: <FaShieldAlt /> },
    { name: "Audit Services", icon: <FaRegListAlt /> },
    { name: "Retirement Planning", icon:  <FaHome /> }, 
    { name: "Wealth Management", icon: <FaHandHoldingUsd /> },
    { name: "Estate Planning", icon: <FaFileContract /> }, 
    { name: "Personal Tax Advice", icon: <FaUserTie /> },
    { name: "Charitable Giving", icon: <FaGifts /> }
  ];

  const allServices = [...individualServices];

  const servicesToDisplay = showAll ? allServices : allServices.slice(0, 8);

  const renderCards = (services) => {
    return services.map((service, index) => (
      <div
        key={index}
        className="service-card-item"
        data-aos="fade-up"
      >
        <div className="service-icon">{service.icon}</div>
        <h3>{service.name}</h3>
        <p>Details about {service.name}.</p>
      </div>
    ));
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="services-container">
      <h1 className="section-title" data-aos="fade-down">Our Services</h1>

      <div className="service-cards-container">
        {renderCards(servicesToDisplay)}
      </div>

      {allServices.length > 8 && (
        <button
          className="show-more-btn"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};

export default Services;
